// @ts-nocheck

import { NetworkActionTypes } from '../../types/actions/network';
import { type HandlerProps } from '../synchronousMiddleware';

const currentQueries = {};

export const handledActionTypes = [NetworkActionTypes.SEND, NetworkActionTypes.RECV];

const webSocketAsyncMiddlewareHandler = ({ action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    const { type, payload, meta } = action;

    if (type === NetworkActionTypes.SEND && meta) {
      const { queryId, hooks } = meta;

      if (hooks && queryId && !currentQueries[queryId]) {
        const { onSuccess, onError, onFinally } = hooks;

        currentQueries[queryId] = {
          onSuccess,
          onError,
          onFinally,
        };
      }
    }

    if (type === NetworkActionTypes.RECV) {
      const whiteListedKeys = [
        'betBuilderResults',
        'searchResults',
        'myMatchResults',
        'favoritesResult',
        'missionsResult',
        'kohlantaResult',
        'monopolyResult',
        'giftRaceResult',
      ];

      const validKey = whiteListedKeys.find((key) => !!payload?.[key]);

      if (validKey) {
        const receivedData = payload?.[validKey];
        const { id, result, error } = receivedData ?? {};

        const pendingQuery = currentQueries[id];

        if (pendingQuery) {
          const { onSuccess, onError, onFinally } = pendingQuery;

          if (result && typeof onSuccess === 'function') {
            onSuccess(result);
          } else if (error && typeof onError === 'function') {
            onError(error);
          }

          if (typeof onFinally === 'function') {
            onFinally();
          }

          delete currentQueries[id];
        }
      }
    }
  }
};

export default webSocketAsyncMiddlewareHandler;
